import React from "react"

import {FieldGlistEditableProps} from "../../../../render/glist/glist-editable"
import {TimeValue} from "../../../../../gd/types/datetime"

const debug = false
// const debug = "FieldTimeOfDay_GListEditable"

type State = {
    initialPropsValue   : any, // required to check if currentOption update needed on props changed
    currentValue        : any,
    showPopover         : boolean
}

export default class FieldTimeOfDay_GListEditable extends React.Component<FieldGlistEditableProps, State> {

    constructor(props:FieldGlistEditableProps) {
        super(props);

        const value = props.field.getViewValue(props.model)
        debug && console.log(debug, "constructor", value)

        this.state = {
            initialPropsValue   : value, // required to check if currentOption update needed on props changed
            currentValue        : value,
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId]

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentValue        : props.field.getViewValue(props.model)
            }
        }

        return null // no changes
    }

    resetValue = () => {
        this.hidePopover()

        this.props.onChange && this.props.onChange(null)
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()
        if (!this.state.showPopover) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    setValue = (value:TimeValue) => {
        this.hidePopover()

        const result: Moment = this.state.initialPropsValue ? moment(this.state.initialPropsValue) : moment()
        result.hours(value.hours)
        result.minutes(value.minutes)
        result.seconds(0)
        result.milliseconds(0)

        this.props.onChange && this.props.onChange(result)
    }

    onOptionClick = (option:any) => {
        this.setValue(option.value)
    }

    render() {
        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        })

        // need check value because of none
        if (this.state.currentValue) {
            return (
                <field.components.ListValueNotEmpty className={classes}
                                                    field={this.props.field}
                                                    value={this.state.currentValue}
                                                    onClick={this.showPopover}
                                                    onReset={this.resetValue}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.ListValueNotEmpty>
            )
        } else {
            return (
                <field.components.ListValueEmpty className={classes} field={this.props.field} onClick={this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.ListValueEmpty>
            )
        }
    }
}
